// extracted by mini-css-extract-plugin
module.exports = {"paginationUl":"styles_paginationUl__w9dtd","paginationItemSelected":"styles_paginationItemSelected__1igPr"};